import { Box, Loader } from '@mantine/core';
import clsx from 'clsx';
import styles from './ManifestBadge.module.scss';

interface ManifestBadgeProps {
  children?: number | string;
  active?: boolean;
  isLoading?: boolean;
  id?: string;
  dataTestId?: string;
}

const ManifestBadge = ({
  children,
  active,
  isLoading,
  dataTestId,
  ...props
}: ManifestBadgeProps) => {
  return (
    <Box
      {...props}
      data-testid={dataTestId}
      className={clsx(styles.badge, active && styles.badgePrimaryActive)}
    >
      {isLoading && <Loader color="white" size={'xs'} variant="dots" />}
      {!isLoading && (
        <span
          className={clsx(
            styles.textContainer,
            styles.badgeText,
            styles.badgePrimaryText,
            active && styles.badgePrimaryTextActive,
          )}
        >
          {children}
        </span>
      )}
    </Box>
  );
};

export default ManifestBadge;
